<template>
  <div>
    <shadowBackground></shadowBackground>
    <div class="tab_wrapper">
      <div :style="scaleStyle" class="tab_welcome_popup">
        <popupsBackground :height="heightBack" :width="widthBack" />
        <div class="welcome-box">
          <div class="close-popup" @click="closePopup">
            <div class="wrapper_btn_close"></div>
          </div>
          <div class="tabWrapper">
            <div class="tab-box">
              <div :style="sliderStyle" class="tab__slider">
                <div class="tab__slider_inner"></div>
              </div>
              <div :class="getTabIndexPopup ? 'disable-text' : ''" class="tab__item" @click="onTabClick(0)">
                {{ $t('rules') }}
              </div>
              <div :class="getTabIndexPopup ? '' : 'disable-text'" class="tab__item" @click="onTabClick(1)">
                {{ $t('freebet.title') }}
              </div>
            </div>
          </div>
          <div class="slider">
            <welcomeRules :class="getTabIndexPopup ? 'left100_back' : 'left0'" class="slider-item" />
            <welcomeFreeBets
              :activeId="activeId"
              :class="getTabIndexPopup ? 'left0' : 'left100'"
              class="slider-item"
              @onClickSelect="onClickSelect"
              @selectFreeBet="selectFreeBet" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import shadowBackground from '@/components/otherComponents/ShadowBackground.vue';
import popupsBackground from '@/components/otherComponents/PopupsBackground.vue';
import welcomeRules from '@/components/welcome_popup/tabWelcome/WelcomeRules.vue';
import welcomeFreeBets from '@/components/welcome_popup/tabWelcome/WelcomeFreeBets.vue';
import { mapActions, mapGetters } from 'vuex';
import { ACTION } from '@/store/ACTION';

export default Vue.extend({
  name: 'TabWelcomeWrapper',
  components: {
    shadowBackground,
    popupsBackground,
    welcomeRules,
    welcomeFreeBets
  },
  data: () => ({
    activeId: 0,
    finalId: 0
  }),
  computed: {
    ...mapGetters(['getAppConfiguration', 'getTabIndexPopup']),
    scaleStyle(): { transform: string; top: string; left: string } {
      const offset: { top: number; left: number } = {
        top: this.isLandscape ? 628 / 2 : 863 / 2,
        left: this.isLandscape ? 979 / 2 : 520 / 2
      };
      const scale: number = this.uiScale;
      const addScale: number = this.isLandscape ? 1.5 : 2;

      return {
        transform: `scale(${scale * addScale})`,
        top: `calc(50% - ${offset.top}px)`,
        left: `calc(50% - ${offset.left}px)`
      };
    },
    isLandscape(): boolean {
      return this.getAppConfiguration.isLandscape;
    },
    uiScale(): number {
      return this.getAppConfiguration.scale;
    },
    heightBack(): number {
      return this.isLandscape ? 628 : 863;
    },
    widthBack(): number {
      return this.isLandscape ? 979 : 520;
    },
    sliderStyle(): any {
      return {
        left: this.getTabIndexPopup ? '50%' : 0
      };
    }
  },
  methods: {
    ...mapActions(['setTabIndexPopup']),
    onTabClick(id: number): void {
      this.setTabIndexPopup({ position: id });
    },
    closePopup(): void {
      this.updateValues();
      promoApp.eventEmitter.emit(ACTION.SET_TAB_WELCOME_VISIBLE, { visible: false });
    },
    onClickSelect({ id = 0 }: { id: number }): void {
      this.activeId = id;
    },
    updateValues(): void {
      this.activeId = this.finalId;
    },
    selectFreeBet(): void {
      this.finalId = this.activeId;
      promoApp.eventEmitter.emit(ACTION.SET_TAB_WELCOME_VISIBLE, { visible: false });
      promoApp.eventEmitter.emit(ACTION.SET_FREE_BET, { id: this.finalId });
    }
  }
});
</script>

<style lang="scss" scoped>
.tab_wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  font-family: 'myriadpro-boldcond';
  color: white;
}

.tab_welcome_popup {
  position: absolute;
}

.welcome-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 16px 25px 20px 20px;
  display: flex;
  flex-direction: column;
}

.tabWrapper {
  display: flex;
  justify-content: center;
}

.tab-box {
  display: flex;
  width: 80%;
  height: 38px;
  background-color: black;
  border-radius: 23px;
  position: relative;
}

.tab__slider {
  position: absolute;
  width: 50%;
  height: 100%;
  transition: all 0.3s ease;
  border-radius: 23px;
  top: 0;
  z-index: 1;
  padding: 5px;
}

.tab__slider_inner {
  border-radius: 23px;
  background-color: #2d2f30;
  width: 100%;
  height: 100%;
}

.tab__item {
  flex: 0 0 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 23px;
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
  font-size: 27px;
}

.disable-text {
  color: #515557;
}

.slider {
  width: 100%;
  overflow: hidden;
  height: 100%;
  position: relative;
}

.slider-item {
  position: absolute;
  top: 0;
  width: 100%;
  transition: all 0.5s ease;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.left0 {
  left: 0;
}

.left100 {
  left: 100%;
}

.left100_back {
  left: -100%;
}

.close-popup {
  position: absolute;
  cursor: pointer;
  z-index: 1;
  top: 20px;
  right: 25px;
  transition: all 0.1s ease;

  &:hover {
    .wrapper_btn_close:after {
      background-color: white;
    }

    .wrapper_btn_close:before {
      background-color: white;
    }
  }
}

.wrapper_btn_close {
  width: 32px;
  height: 32px;
  position: relative;
}

.wrapper_btn_close:after {
  content: '';
  display: block;
  width: 28px;
  height: 5px;
  background-color: #b4b4b4;
  position: absolute;
  top: 14px;
  left: 3px;
  transform: rotate(45deg);
  transition: all 0.3s ease;
}

.wrapper_btn_close:before {
  content: '';
  display: block;
  width: 28px;
  height: 5px;
  background-color: #b4b4b4;
  position: absolute;
  top: 14px;
  left: 3px;
  transform: rotate(-45deg);
  transition: all 0.3s ease;
}
</style>